import React from 'react'
import styled from 'styled-components'
import Container from 'src/react/layout/container'
import { color } from "src/styles/variables";

const heroImage = `//images.ctfassets.net/itvcls9imtx8/2sCjb5UZlV4sRyLZfDAntR/c22ae9fee35d55865ac383536616db0e/Top-Gift-Image-optimised.jpg`

function Hero() {
  return (
    <Wrapper>
      <Container>
        <Inner>
          <Title>Give the perfect gift</Title>
          <Subtitle>
            Men are notoriously hard to buy for - whether it's birthdays,
            Christmas, Father's Day or Valentine's. But with Cornerstone, it
            couldn't be easier to buy the perfect gift.
          </Subtitle>
        </Inner>
      </Container>
    </Wrapper>
  )
}

export default Hero

const smallBreakPoint = '@media (min-width: 460px)'
const mediumBreakPoint = '@media (min-width: 768px)'
const largeBreakPoint = '@media (min-width: 960px)'

const Wrapper = styled.div`
  padding: 20px 0 30px;
  color: ${color.white};
  background-size: cover;
  background-image: url(${heroImage}?w=1536);
  ${mediumBreakPoint} {
    background-image: url(${heroImage});
    background-repeat: no-repeat;
    padding-top: 60px;
    padding-bottom: 40px;
    background-position: 95%;
  }
  ${largeBreakPoint} {
    height: 380px;
    background-position: 75% 40%;
  }
`

const Inner = styled.div`
  position: relative;
  z-index: 10;
  text-align: left;
  ${largeBreakPoint} {
    margin-top: 35px;
  }
`

const Title = styled.h1`
  font-size: 28px;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 15px;
  ${smallBreakPoint} {
    font-size: 32px;
  }
  ${mediumBreakPoint} {
    font-size: 40px;
  }
`

const Subtitle = styled.h2`
  font-weight: 400;
  max-width: 500px;
  ${smallBreakPoint} {
    font-size: 18px;
  }
  ${mediumBreakPoint} {
    font-size: 20px;
  }
`
